// LanguageService: detection, validation, loading, caching, persistence
import { i18nUtils } from '../utils';

const memoryCache = {
  translations: new Map(), // lang -> translations object
};

const STORAGE_KEYS = {
  lang: i18nUtils.LANGUAGE_STORAGE_KEY,
};

const VALID_LANGS = i18nUtils.SUPPORTED_LANGUAGES;

const loadStatic = async (lang) => {
  // Static import fallback (bundled)
  if (lang === 'bg') {
    const mod = await import('../translations/bg');
    return mod.default || mod;
  }
  if (lang === 'en') {
    const mod = await import('../translations/en');
    return mod.default || mod;
  }
  return {};
};

export class LanguageService {
  static detect() {
    return i18nUtils.getInitialLanguage();
  }

  static validate(lang) {
    return VALID_LANGS.includes(lang);
  }

  static getStored() {
    return i18nUtils.loadStoredLanguage();
  }

  static store(lang) {
    i18nUtils.storeLanguage(lang);
  }

  static async loadTranslations(lang, { forceReload = false } = {}) {
    const target = this.validate(lang) ? lang : i18nUtils.DEFAULT_LANGUAGE;
    if (!forceReload && memoryCache.translations.has(target)) {
      return memoryCache.translations.get(target);
    }
    const data = await loadStatic(target);
    memoryCache.translations.set(target, data || {});
    return data || {};
  }

  static getCached(lang) {
    return memoryCache.translations.get(lang) || null;
  }

  static async ensure(lang) {
    const target = this.validate(lang) ? lang : i18nUtils.DEFAULT_LANGUAGE;
    const cached = this.getCached(target);
    if (cached) return cached;
    return this.loadTranslations(target);
  }
}

export default LanguageService;


